import { render, staticRenderFns } from "./file-logo.vue?vue&type=template&id=fecc7054&"
import script from "./file-logo.vue?vue&type=script&lang=js&"
export * from "./file-logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports